export function isNullOrWhitespace(value) {
    return !value || value.trim().length === 0;
}

export function replaceString(source: string, ...props: string[]): string {
    if (source === undefined) return "";

    for (const i in props) source = source.replace(new RegExp("\\{" + i + "\\}", "g"), props[i]);

    return source;
}
